import React from 'react';
import { useParams } from 'react-router-dom';
import blogPosts from './data/blogPosts';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

function BlogArticle({ language }) {
  const { slug } = useParams();
  const post = blogPosts.find(p => p.slug === slug);

  const isLTR = ['en', 'fr'].includes(language);

  if (!post) {
    return (
      <div className='about-container-inner'>
        <div className="about-container">
          <p
            className={`about-text ${isLTR ? 'about-english' : ''}`}
            dir={isLTR ? 'ltr' : 'rtl'}
            style={{ textAlign: isLTR ? 'left' : 'right' }}
          >
            {language === 'ar'
              ? 'المقال غير موجود'
              : language === 'fr'
                ? 'Article introuvable'
                : 'Article not found'}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className='about-container-inner'>
      <div className="about-container">
        <h1
          className={`about-title ${isLTR ? 'english-title' : ''}`}
          dir={isLTR ? 'ltr' : 'rtl'}
          lang={language}
        >
          {post.titles[language]}
        </h1>

        <p
          className={`about-text ${isLTR ? 'about-english' : ''}`}
          dir={isLTR ? 'ltr' : 'rtl'}
          style={{
            textAlign: isLTR ? 'left' : 'right',
            color: '#8b7355',
            fontStyle: 'italic'
          }}
        >
          {post.dates[language]}
        </p>

        <div
          className={`blog-article-content ${isLTR ? 'about-english' : ''}`}
          dir={isLTR ? 'ltr' : 'rtl'}
          lang={language}
          style={{ textAlign: isLTR ? 'left' : 'right' }}
        >
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
              h1: ({ node, ...props }) => (
                <h1
                  style={{
                    direction: language === 'ar' ? 'rtl' : 'ltr',
                    textAlign: language === 'ar' ? 'right' : 'left'
                  }}
                  {...props}
                >
                  {props.children}
                </h1>
              ),
              h2: ({ node, ...props }) => (
                <h2
                  style={{
                    direction: language === 'ar' ? 'rtl' : 'ltr',
                    textAlign: language === 'ar' ? 'right' : 'left'
                  }}
                  {...props}
                >
                  {props.children}
                </h2>
              ),
              p: ({ node, ...props }) => (
                <p
                  style={{
                    direction: language === 'ar' ? 'rtl' : 'ltr',
                    textAlign: language === 'ar' ? 'right' : 'left'
                  }}
                  {...props}
                >
                  {props.children}
                </p>
              )
            }}
            skipHtml
          >
            {post.contents[language]}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
}

export default BlogArticle;
